var map = {
	"./logo-big-picture-medical-mark.svg": 59231,
	"./logo-big-picture-medical-regular.svg": 86976,
	"./logo-jnj-mark.svg": 6086,
	"./logo-jnj-regular.svg": 56179,
	"./logo-menicon-mark.svg": 23045,
	"./logo-menicon-regular.svg": 41054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51338;